
import { Component, Prop } from 'vue-property-decorator';
import Vue from 'vue';
import Toasted from 'vue-toasted';
import GroupsForSurvey from '../group/GroupsForSurvey';
import UserPresenceModal from './UserPresenceModal';

Vue.use(Toasted, { duration: 2000 });

@Component({
  components: {
    GroupsForSurvey,
    UserPresenceModal,
  },
})
export default class AdvanceRegistration extends Vue {
  @Prop({ default: false })
  readonly remote!: boolean;
}
